import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { Box, Tooltip } from '@mui/material';
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined';

interface INoteIndicatorCellRendererProps extends ICellRendererParams {
    value: string | null | undefined;
}

// Compact visual indicator, shown to the right of the row Actions menu,
// denoting that a Note has been added for this worksheet column.
const NoteIndicatorCellRenderer: React.FC<INoteIndicatorCellRendererProps> = (params) => {
    const currentValue: string = params.value ?? '';
    const hasNote = currentValue.trim().length > 0;

    if (!hasNote) {
        return null;
    }

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
            }}
        >
            <Tooltip title="Note added" placement="top" arrow>
                <StickyNote2OutlinedIcon
                    fontSize="small"
                    sx={{ color: 'grey.500' }}
                    aria-label="Note added"
                />
            </Tooltip>
        </Box>
    );
};

export default NoteIndicatorCellRenderer;
